var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTriangleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83468 11.4017C8.43944 12.0007 7.56058 12.0007 7.16533 11.4017L4.40443 7.21743C3.96574 6.55257 4.44256 5.66669 5.23911 5.66669L10.7609 5.66669C11.5575 5.66669 12.0343 6.55257 11.5956 7.21743L8.83468 11.4017Z",
    fill: "#0D1A16B2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleLight);
export default __webpack_public_path__ + "static/media/triangleLight.af00ee0b561c551187172daaa50a70ea.svg";
export { ForwardRef as ReactComponent };